/**
 * MCP tool response helpers.
 *
 * @module
 */

import type { ToolResult } from '@chatsdet/browser-core';

export function toolText(text: string) {
  return { content: [{ type: 'text' as const, text }] };
}

export function toolJson(data: unknown) {
  return { content: [{ type: 'text' as const, text: JSON.stringify(data, null, 2) }] };
}

/**
 * Convert a BrowserToolExecutor result to MCP SDK content blocks.
 */
export function formatMCPContent(result: ToolResult) {
  if (typeof result === 'string') {
    return { content: [{ type: 'text' as const, text: result }] };
  }

  // MCPContentResult with text and optional images
  const content: Array<{ type: 'text'; text: string } | { type: 'image'; data: string; mimeType: string }> = [];

  if (result.text) {
    content.push({ type: 'text', text: result.text });
  }

  for (const img of result.images ?? []) {
    content.push({ type: 'image', data: img.data, mimeType: img.mimeType });
  }

  return { content };
}
